<template>
    <BaseSection
        width="page-extra-wide"
        class="team-overview"
    >
        <BaseGrid class="base-grid--filter">
            <BaseMultiselect
                v-model="selectedCategories"
                :label="t('toegewezen_bijdragen.filter.department.label')"
                :inner-label="t('toegewezen_bijdragen.filter.department.placeholder')"
                :options="categoryOptions"
            />
        </BaseGrid>

        <BaseGrid
            v-if="!pending && teamMembers?.length > 0"
            :columns="2"
            class="base-grid--stretch team-overview__cards"
        >
            <ContactCard
                v-for="(teamMember, i) in teamMembers"
                :key="i"
                :team-member="teamMember"
            />
        </BaseGrid>

        <BaseSpinner v-if="pending" />

        <div
            v-if="!pending && teamMembers?.length < 1"
            style="margin-top: 2rem;"
        >
            {{ t('teamOverview.no_results') }}
        </div>
    </BaseSection>
</template>

<script setup>
import getTeamMembers from '~/graphql/queries/getTeamMembers.graphql';
import { isEmpty } from 'lodash-es';

const { t } = useI18n();

const { variables: defaultVariables } = useCraftGraphql();

const fakeCurrentPageRef = ref(0);

// Category
const { options: categoryOptions, selected: selectedCategories } = await useCategory(
    'teamDepartment',
    'categorie',
    fakeCurrentPageRef
);

// FILTER FOR GQL
const relatedToCategories = computed(() => {
    const vars = [];

    if (selectedCategories.value) {
        for (const item of selectedCategories.value) {
            vars.push({
                group: 'teamDepartment',
                slug: item,
                site: defaultVariables.site,
            });
        }
    }

    return vars;
});

const variables = computed(() => {
    const vars = {
        ...defaultVariables,
        uri: undefined, // We don't need the URI for this query
    };

    if (!isEmpty(relatedToCategories.value)) {
        vars.relatedToCategories = relatedToCategories.value;
    }

    return vars;
});

const { data, pending } = await useLazyAsyncQuery({
    query: getTeamMembers,
    variables
});

const teamMembers = computed(() => {
    return data.value?.entries?.filter((member) => member?.showInOverview);
});
</script>

<style lang="less" src="./TeamOverview.less" />
